import React from 'react'
import Paper from '@material-ui/core/Paper'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    marginBottom: 30,
    borderRadius: 4,
    textAlign: 'center',
    textTransform: 'uppercase',
    marginTop: -18
  },
  button: {
    padding: 18,
    borderWidth: 2
  }
})

const LoadMoreButton = ({ loading, ...rest }) => {
  const classes = useStyles()
  return (
    <Paper component={'article'} className={classes.root} elevation={2}>
      <Button color={'primary'} disabled={!!loading} fullWidth className={classes.button} {...rest}>
        {!loading ? 'Mostrar mais' : 'Carregando...'}
      </Button>
    </Paper>
  )
}
export default LoadMoreButton
